<template>
    <div v-bind:class="cssCompiled">
        <slot/>
    </div>
</template>

<script>
    export default {
        name: "SkeletonBox",
        computed: {
            cssCompiled: function () {
                return {
                    'skeleton-box': this.loading === true,
                    'w-1/3': this.loading === true,
                    'h-5': this.loading === true,
                }
            }
        },
        props: {loading: Boolean, css: String},
    }
</script>

<style lang="scss" scoped>
    .skeleton-box {
        position: relative;
        overflow: hidden;
        background-color: #e2e8f0;

        &::after {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            transform: translateX(-100%);
            background-image: linear-gradient(
                            90deg,
                            rgba(255, 255, 255, 0) 0,
                            rgba(255, 255, 255, 0.2) 20%,
                            rgba(255, 255, 255, 0.5) 60%,
                            rgba(255, 255, 255, 0)
            );
            animation: shimmer 3s infinite;
            content: '';
        }
    }
</style>